"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const mongoose_1 = require("mongoose");
const enum_1 = require("./enum");
const roleSchema = new mongoose_1.Schema({
    type: { type: String, enum: Object.values(enum_1.ROLES) },
    description: { type: String },
    is_custom: { type: Boolean, default: false },
    permissions: [{ type: mongoose_1.Schema.Types.ObjectId, ref: "Permission" }],
});
exports.default = (0, mongoose_1.model)("Role", roleSchema);
